export const GET_RESOURCES = 'GET_RESOURCES';
export const SET_COUPONS = 'SET_COUPONS';
export const SET_FILTERS = 'SET_FILTERS';
